import script from "./AwardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AwardView.vue?vue&type=script&setup=true&lang=js"

import "./AwardView.vue?vue&type=style&index=0&id=0a4e265d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a4e265d"]])

export default __exports__